'use strict';

// define a mixin object
export default {
  data() {
    return {
      password_regex_global: /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      password_regex: {
        nb_chars: {
          regex: /^.{8,}$/,
          valid: false
        },
        upper: {
          regex: /(?=[A-Z])./,
          valid: false
        },
        lower: {
          regex: /(?=[a-z])./,
          valid: false
        },
        spe: {
          regex: /(?=[-!$%^&£€#¥§*()_+|~=`{}\[\]:\";'<>?,.\/])./,
          valid: false
        },
      }
    }
  },
  mounted() {

  },
  methods: {
    checkRulesPassword(password) {
      for(let key in this.password_regex) {
        let regex = RegExp(this.password_regex[key].regex);
        if(regex.test(password)) {
          this.password_regex[key].valid = true;
        } else {
          this.password_regex[key].valid = false;
        }
      }
    },
    showPassword(ref) {
      let actual_type = this.$refs[ref].type;
      if(actual_type === 'password')
        this.$refs[ref].type = 'text';

      if(actual_type === 'text')
        this.$refs[ref].type = 'password';
    }
  }
}
